var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pending-table-container",staticStyle:{"max-height":"100%","min-height":"100%","overflow-x":"hidden","overflow-y":"hidden"}},[_c('div',{staticClass:"is-size-5",staticStyle:{"width":"100%","color":"gray","font-weight":"400","font-size":"15px","margin":"20px auto","font-family":"Poppins"}}),_c('TableComponent',{attrs:{"height":"58vh","columns":_vm.columns,"tableData":_vm.pendingList,"objectList":_vm.filterFields,"isLoading":_vm.isLoading},on:{"tableFilter":() => {
        _vm.tableFilterRequestHandler();
      },"resetFilter":() => {
        _vm.resetFilter();
      }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }